import React, { useContext } from 'react';
import { MobileContext } from '../Context';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import DesktopArtStage from './DesktopArtStage';
import DesktopLiteratureArtStage from './DesktopLiteratureArtStage';
import MobileArtStage from './MobileArtStage';
import CommissionStage from './CommissionStage';
import SimpleStage from './_partials/SimpleStage';
import { useFlag } from '../redux/flags/hooks';
export var ArtStage = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var isMobile = useContext(MobileContext);
    var duperEverywhere = useFlag('duper_everything');
    if (isMobile) {
        return (React.createElement(MobileArtStage, { deviation: deviation, className: className, isZoomed: isZoomed, onEnterZoomMode: function () { return onEnterZoomMode(deviation); }, onExitZoomMode: function () { return onExitZoomMode(deviation); } }));
    }
    switch (getDeviationType(deviation)) {
        case DeviationTypes.POLL:
        case DeviationTypes.STATUS:
            return (React.createElement(SimpleStage, { deviation: deviation, withDuperbrowsePaddles: duperEverywhere }));
        case DeviationTypes.COMMISSION:
            return (React.createElement(CommissionStage, { deviation: deviation, withDuperbrowsePaddles: duperEverywhere }));
        case DeviationTypes.LITERATURE:
            return (React.createElement(DesktopLiteratureArtStage, { deviation: deviation, className: className }));
        default:
            return (React.createElement(DesktopArtStage, { deviation: deviation, isOwner: isOwner, className: className, isZoomed: isZoomed, withDuperbrowsePaddles: true, onEnterZoomMode: function () { return onEnterZoomMode(deviation); }, onExitZoomMode: function () { return onExitZoomMode(deviation); } }));
    }
};
ArtStage.displayName = 'ArtStage';
export default ArtStage;
//# sourceMappingURL=ArtStage.js.map